import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DeliveriesTab } from '@/features/shipment-detail/deliveries/deliveries-tab';

// S06 · Deliveries to Dokless (07 §3). `?row=<id>` selects a payload or note, `?view=` the viewer's tab.
export const Route = createFileRoute('/_app/shipments/$id/deliveries')({
  validateSearch: z.object({
    row: z.string().optional(),
    view: z.enum(['diff', 'json', 'resp']).optional(),
  }),
  component: DeliveriesTab,
});
